/** Lowercase without diacritics, so "amoniak" finds "Amoniak" and "horlave" finds "hořlavé". */
export const normalize = (text: string) =>
  text
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
